import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppBar, Toolbar, Typography, IconButton } from '@material-ui/core'
import { ExitToApp as ExitToAppIcon, Menu, MenuOpen } from '@material-ui/icons'
import { resetFilters } from 'state/modules/dashboard'
import { logout } from '~/state/modules/login'
import { toggleSidebar } from '~/state/modules/app'
import ReactCountryFlag from 'react-country-flag'
import { useTheme, useMediaQuery } from '@material-ui/core'
import { useStyles } from './AppToolbar.style'

export const AppToolbar = ({ title }) => {
  const dispatch = useDispatch()
  const classes = useStyles()
  const { country, isSidebarCollapsed } = useSelector((state) => state.app)
  const theme = useTheme()
  const isUpMedium = useMediaQuery(theme.breakpoints.up('md'), { noSsr: true })

  const handleLogout = () => {
    dispatch(resetFilters())
    dispatch(logout())
  }

  const handleColapseMenu = () => {
    dispatch(toggleSidebar())
  }

  return (
    <AppBar className={classes.appBar} position='relative'>
      <Toolbar>
        {isUpMedium && (
          <IconButton
            edge='start'
            onClick={handleColapseMenu}
            color='inherit'
            style={{ marginRight: 8 }}>
            {isSidebarCollapsed ? <Menu /> : <MenuOpen />}
          </IconButton>
        )}
        <Typography variant='h6' noWrap className={classes.title}>
          {title}
        </Typography>
        <Typography variant='h4'>
          {country} - &nbsp;
          <ReactCountryFlag countryCode={country} svg />
        </Typography>
        <IconButton edge='end' onClick={handleLogout} color='inherit'>
          <ExitToAppIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  )
}

export default AppToolbar
